import { render, staticRenderFns } from "./SecondaryBanner.vue?vue&type=template&id=a9c28adc&scoped=true&"
import script from "./SecondaryBanner.vue?vue&type=script&lang=js&"
export * from "./SecondaryBanner.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryBanner.vue?vue&type=style&index=0&id=a9c28adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c28adc",
  null
  
)

export default component.exports